module.exports = {"450125100":"大丰镇","450125101":"明亮镇","450125102":"巷贤镇","450125103":"白圩镇","450125104":"三里镇","450125105":"乔贤镇","450125106":"西燕镇","450125200":"澄泰乡","450125202":"木山乡","450125203":"塘红乡","450125205":"镇圩瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450125.json
// module id = 2204
// module chunks = 0